var _defs, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 788,
    height: 206,
    viewBox: "0 0 788 206",
    fill: "none",
    id: "svg16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236.271 63.0195H249.76V204H236.271V63.0195Z",
    fill: "black",
    id: "path4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.146 204.95C318.519 204.95 309.843 202.796 302.116 198.49C294.389 194.056 288.309 187.976 283.876 180.25C279.443 172.523 277.226 163.783 277.226 154.03C277.226 144.276 279.443 135.536 283.876 127.81C288.309 120.083 294.389 114.066 302.116 109.76C309.843 105.453 318.519 103.3 328.146 103.3C337.773 103.3 346.449 105.453 354.176 109.76C361.903 114.066 367.919 120.083 372.226 127.81C376.659 135.536 378.876 144.276 378.876 154.03C378.876 163.783 376.659 172.523 372.226 180.25C367.919 187.976 361.903 194.056 354.176 198.49C346.449 202.796 337.773 204.95 328.146 204.95ZM328.146 192.98C335.239 192.98 341.573 191.396 347.146 188.23C352.846 184.936 357.279 180.313 360.446 174.36C363.613 168.406 365.196 161.63 365.196 154.03C365.196 146.43 363.613 139.653 360.446 133.7C357.279 127.746 352.846 123.186 347.146 120.02C341.573 116.726 335.239 115.08 328.146 115.08C321.053 115.08 314.656 116.726 308.956 120.02C303.383 123.186 298.949 127.746 295.656 133.7C292.489 139.653 290.906 146.43 290.906 154.03C290.906 161.63 292.489 168.406 295.656 174.36C298.949 180.313 303.383 184.936 308.956 188.23C314.656 191.396 321.053 192.98 328.146 192.98Z",
    fill: "black",
    id: "path6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M421.237 198.49C429.09 202.796 437.957 204.95 447.837 204.95C456.324 204.95 463.987 203.303 470.827 200.01C477.667 196.59 483.05 191.65 486.977 185.19L476.907 178.35C473.614 183.29 469.434 186.963 464.367 189.37C459.3 191.776 453.79 192.98 447.837 192.98C440.617 192.98 434.094 191.396 428.267 188.23C422.567 184.936 418.07 180.376 414.777 174.55C411.61 168.596 410.027 161.756 410.027 154.03C410.027 146.43 411.61 139.653 414.777 133.7C418.07 127.746 422.567 123.186 428.267 120.02C434.094 116.726 440.617 115.08 447.837 115.08C453.79 115.08 459.3 116.346 464.367 118.88C469.434 121.286 473.614 124.96 476.907 129.9L486.977 123.06C483.05 116.6 477.667 111.723 470.827 108.43C464.114 105.01 456.45 103.3 447.837 103.3C437.957 103.3 429.09 105.453 421.237 109.76C413.51 114.066 407.43 120.083 402.997 127.81C398.564 135.536 396.347 144.276 396.347 154.03C396.347 163.783 398.564 172.586 402.997 180.44C407.43 188.166 413.51 194.183 421.237 198.49Z",
    fill: "black",
    id: "path8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M549.043 153.84L525.483 175.5V204H511.993V63.0195H525.483V158.59L585.143 104.06H601.863L559.113 144.91L605.853 204H589.323L549.043 153.84Z",
    fill: "black",
    id: "path10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M625.443 158.21H709.042L709.232 154.03C709.232 144.15 707.142 135.41 702.962 127.81C698.782 120.083 693.019 114.066 685.672 109.76C678.326 105.453 670.029 103.3 660.782 103.3C651.536 103.3 643.176 105.453 635.702 109.76C628.356 114.066 622.529 120.083 618.222 127.81C614.042 135.536 611.952 144.276 611.952 154.03C611.952 163.783 614.169 172.523 618.602 180.25C623.036 187.976 629.179 194.056 637.032 198.49C645.012 202.796 654.132 204.95 664.392 204.95C672.372 204.95 679.656 203.556 686.242 200.77C692.956 197.983 698.529 193.93 702.962 188.61L695.362 179.87C691.562 184.176 687.066 187.47 681.872 189.75C676.679 191.903 670.979 192.98 664.772 192.98C653.752 192.98 644.632 189.813 637.412 183.48C630.193 177.02 626.203 168.596 625.443 158.21ZM636.462 124.2C643.049 117.993 651.156 114.89 660.782 114.89C670.536 114.89 678.642 117.993 685.102 124.2C691.689 130.28 695.426 138.26 696.312 148.14H625.443C626.329 138.26 630.002 130.28 636.462 124.2Z",
    fill: "black",
    id: "path12"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M749.61 123.63C752.777 116.916 757.464 111.85 763.67 108.43C770.004 105.01 777.794 103.3 787.04 103.3V116.41L783.81 116.22C773.297 116.22 765.064 119.45 759.11 125.91C753.157 132.37 750.18 141.426 750.18 153.08V204H736.69V104.06H749.61V123.63Z",
    fill: "black",
    id: "path14"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillRule: "evenodd",
      strokeWidth: 0.977312
    },
    id: "rect1031",
    width: 12.960816,
    height: 31.768679,
    x: 111.24135,
    y: 71.795036
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillRule: "evenodd",
      strokeWidth: 1.54459
    },
    id: "rect1031-6",
    width: 12.990887,
    height: 79.168213,
    x: 103.56371,
    y: -124.20216,
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "C",
    transform: "scale(1.0607659,0.94271508)",
    id: "text3034",
    style: {
      fontSize: "298.612px",
      lineHeight: 1.25,
      fill: "#000000",
      strokeWidth: 1.29831
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 104.01752,26.46846 q -34.118755,0 -53.073618,22.016803 -18.954863,21.870996 -18.954863,60.072337 0,37.76392 19.683896,60.80137 19.829703,22.89164 53.511035,22.89164 43.15877,0 64.88396,-42.72135 l 22.74583,11.37292 q -12.68517,26.53681 -35.72262,40.38844 -22.89165,13.85163 -53.21943,13.85163 -31.056812,0 -53.802648,-12.83098 Q 27.469033,189.33448 15.512889,165.42219 3.7025506,141.36409 3.7025506,108.5576 q 0,-49.136839 26.5368084,-76.985907 26.536809,-27.8490688 73.486551,-27.8490688 32.80649,0 54.82329,12.8309848 22.01681,12.830984 32.36908,38.055533 L 164.52727,63.35754 Q 157.38275,45.423323 141.48983,35.945892 125.74271,26.46846 104.01752,26.46846 Z",
    style: {
      fontFamily: "'Liberation Sans'",
      InkscapeFontSpecification: "'Liberation Sans'"
    },
    id: "path44614"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.56543e7726aff546e254455ef131fc2e.svg";
export { ForwardRef as ReactComponent };